<template>
<div class="chapter">
<div class="inner_page">
<p class="otherfm"><a id="page_i"><em>The scent made him freeze in place</em>.</a></p><a id="page_i">
<div class="blockquote1">
<p class="indent">He was held there by a scrap of a memory—one he’d thought forgotten years ago. A memory of exotic violet eyes fringed with thick, black lashes; of hair that slid through his greedy fingers like black silk; of creamy skin that held the sun’s fragrant kiss; and of a lush mouth, ripe for kisses that—</p>
<p class="indent">“Hello, William.”</p>
<p class="indent">The voice possessed a throaty resonance that made even a whisper clear. It was rich, deeper than usual for a woman, and yet still feminine and richly wanton. William knew it as well as his own … and it was the last voice he expected to hear in his own cabin.</p>
<p class="indent">“Aren’t you going to return my greeting? Or are we still not speaking?” The lilting voice ran up and down his spine, as sensual as a warm hand.</p>
<p class="indent">William gritted his teeth against his traitorous body before turning.</p>
<p class="indent">There, sitting in a chair at the head of the captain’s table, was the one woman he’d never wished to see again.</p>
<p class="textright1"><em>Turn the page for rave reviews of<br/>Karen Hawkins’s romantic storytelling</em>…</p>
</div>
<p class="pagebreak">
</p></a><p class="otherfm"><a id="page_i"></a><a id="page_ii">Praise for KAREN HAWKINS</a></p><a id="page_ii">
</a><div class="blockquote1"><a id="page_ii">
<p class="noindent">“Always funny and sexy, a Karen Hawkins book is a sure delight!”</p>
<p class="textright1">—Victoria Alexander</p>
<p class="noindent">“Karen Hawkins writes fast, fun, and sexy stories that are a perfect read for a rainy day, a sunny day, or any day at all!”</p>
<p class="textright1">—Christina Dodd</p>
<p class="noindent">“Karen Hawkins will make you laugh and touch your heart.”</p>
<p class="textright1">—Rachel Gibson</p>
<p class="centerr">and her sparkling historical romances</p>
<p class="centerr"><em>One Night in Scotland</em></p>
<p class="noindent">“Enticing repartee … charming and witty.”</p>
<p class="textright">—<em>Publishers Weekly</em></p>
<p class="noindent">“Readers will be delighted by the perfect pacing, the humorous dialogue and the sizzling sensual romance.”</p>
<p class="textright"><em>—Romantic Times</em> Top Pick</p>
<p class="centerr"><em>Much Ado About Marriage</em></p>
<p class="noindent">“A delicious flirtation that pits a staid Englishman against a fey Scots woman. Humor, forklore, and sizzling love scenes lend this novel the perfect incentive for not wanting to put it down.”</p>
<p class="textright">—<em>Winter Haven News Chief</em> (Florida)</p>
<p class="noindent">“Delightful banter.… Colorful secondary characters … add humor and charm.”</p>
<p class="textright">—<em>Publishers Weekly</em></p>
<p class="centerr"><em>The Laird Who Loved Me</em></p>
<p class="noindent">“Filled with biting reparté, humor, and sexual tension that will keep you turning the pages with glee.”</p>
<p class="textright">—<em>Romantic Times</em> (4½ stars, Top Pick)</p>
</a><p class="noindent"><a id="page_ii"></a><a id="page_iii">“Delightful in every way.”</a></p><a id="page_iii">
<p class="textright">—Reader To Reader</p>
<p class="centerr"><em>Sleepless in Scotland</em></p>
<p class="noindent">“Amusing yet profound.… Readers will be sleepless in America due to a one-sitting enjoyable time.”</p>
<p class="textright">—Harriet Klausner</p>
<p class="noindent">“Made me laugh, cry and fall out of bed.… Karen is an author who will transport you back in time [and] have you placing her on your must-buy list!”</p>
<p class="textright">—Night Owl Reviews (Top Pick)</p>
<p class="centerr"><em>To Catch a Highlander</em></p>
<p class="noindent">“Love and laughter, poignancy and emotional intensity, endearing characters, and a charming plot are the ingredients in Hawkins’s utterly delightful tale.”</p>
<p class="textright">—<em>Romantic Times</em></p>
<p class="noindent">“Fast, sensual, and brilliant.… This is romance at its best!”</p>
<p class="textright">—Romance and More</p>
<p class="centerr"><em>To Scotland, With Love</em></p>
<p class="noindent">“Another winner … there were so many charming bits in it, I can’t even begin to describe them—but I found myself laughing a lot!”</p>
<p class="textright">—Rakehell Reviews</p>
<p class="centerr"><em>How to Abduct a Highland Lord</em></p>
<p class="noindent">“Heated, exciting, and touching. Hawkins excels at taking tried-and-true plotlines and turning them into fresh, vibrant books.”</p>
<p class="textright">—<em>Romantic Times</em></p>
<p class="noindent">“<em>How to Abduct a Highland Lord</em> is laced with passion and drama, and with its wonderfully romantic and thrilling ending, it’s a story you don’t want to miss!”</p>
<p class="textright">—Joyfully Reviewed</p>
</a></div><a id="page_iii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// otherfm.vue?e3dfc398